import {t} from '@/core/utils/t'
import {documentComponent} from '@/core'

export const doc = documentComponent({
  name: 'Header',
  description: '',
  categories: [],
  props: t.object({
    narrow: t.boolean().optional().describe('Sets a max width on the inner elemnts of header.')
  }),
  examples: {
    basic: {
      props: {
      },
      description: ''
    }
  },
  todo: [],
})
